import { FunctionComponent } from "react";

interface HelpProps {}

const Help: FunctionComponent<HelpProps> = () => {
  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-12">
          <h1>Help</h1>
        </div>
      </div>
    </div>
  );
};

export default Help;
